import { render, staticRenderFns } from "./BadgeValueSetting.vue?vue&type=template&id=28c791fe&scoped=true&"
import script from "./BadgeValueSetting.vue?vue&type=script&lang=js&"
export * from "./BadgeValueSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c791fe",
  null
  
)

export default component.exports